import {remCalc} from '_themeUtils'

const modal = {
    Modal: {
        baseStyle: ({variant}) => {
            const isSwitchLocale = variant === 'switchLocale'
            const isChangeLocale = variant === 'changeLocale'
            const isNewsletter = variant === 'NewsletterModal'
            const isMediaZoom = variant === 'mediaZoom'

            const bodyWrapperPadding = () => {
                switch (variant) {
                    case 'NewsletterModal':
                        return {base: `0 ${remCalc(16)} 0 ${remCalc(16)}`, md: `0 ${remCalc(24)} 0 ${remCalc(56)}`}
                    case 'switchLocale':
                    case 'changeLocale':
                        return '0'
                    case 'wishlistSize':
                        return `0 ${remCalc(20)} ${remCalc(56)} ${remCalc(32)}`
                    case 'mediaZoom':
                        return '0'
                    default:
                        return {base: `0 ${remCalc(16)} ${remCalc(24)}`, md: `0 ${remCalc(24)} ${remCalc(24)} ${remCalc(56)}`}
                }
            }
            const marginDialog = () => {
                switch (variant) {
                    case 'mediaZoom':
                        return '0'
                    default:
                        return {base: 'spacing.6', lg: 'spacing.8'}
                }
            }

            return {
                dialogContainer: {
                    zIndex: 'tooltip',
                },
                overlay: {
                    zIndex: 'tooltip',
                },
                dialog: {
                    display: 'flex',
                    flexDirection: 'row',
                    my: marginDialog(),
                    borderRadius: 'borderRadius.modal.base',
                    w: {base: `calc( 100% - ${remCalc(32)})`, md: '100%'},
                    maxW: {base: remCalc(400), md: remCalc(716), lg: remCalc(1020)},
                    h: {base: '100%', md: 'auto'},
                    maxH: {base: `calc(100% - ${remCalc(48)})`, md: remCalc(870)},
                },
                header: {
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    w: '100%',
                    textStyle: 'paragraphSm',
                    fontWeight: '400',
                    padding: `${remCalc(24)} 0 ${remCalc(12)}`,
                    p: {
                        textStyle: 'paragraphSm',
                        color: 'color.text.grey.600',
                    },
                    zIndex: 'docked',
                },
                imageContainer: {
                    pos: 'relative',
                    display: {base: 'none', md: 'block'},
                    maxW: isNewsletter ? {base: remCalc(190), lg: remCalc(320)} : {base: remCalc(190), md: remCalc(320)},
                    w: '100%',
                    minH: isNewsletter ? {base: remCalc(190), lg: remCalc(320)} : remCalc(528),
                    minW: isNewsletter ? {base: remCalc(190), lg: remCalc(320)} : '0',
                },
                dialogWrapper: {
                    w: '100%',
                    alignItems: 'flex-start',
                    gap: isMediaZoom ? 0 : 'spacing.2',
                },
                bodyWrapper: {
                    w: '100%',
                    alignItems: 'flex-start',
                    h: '100%',
                    p: bodyWrapperPadding(),
                    overflowY: isNewsletter || isChangeLocale ? {base: 'auto'} : 'unset',
                },
                body: {
                    w: '100%',
                    p: 0,
                    position: isChangeLocale ? 'relative' : 'unset',
                },
                closeIcon: {
                    sx: {
                        '& button': {
                            color: isSwitchLocale ? 'color.text.white' : 'color.text.black',
                        },
                    },
                },
                footer: {
                    w: '100%',
                    mt: 'auto',
                    justifyContent: 'flex-start',
                    p: !isSwitchLocale && !isChangeLocale ? {base: `0 ${remCalc(16)} ${remCalc(24)}`, md: `0 ${remCalc(24)} ${remCalc(24)} ${remCalc(56)}`} : 0,
                },
            }
        },
        sizes: {},
        variants: {
            changeLocale: {
                dialogContainer: {
                    alignItems: 'center',
                },
                dialog: {
                    h: {base: 'unset'},
                    maxW: {md: remCalc(716), lg: remCalc(874)},
                    maxH: `calc(100% - ${remCalc(48)})`,
                },
                header: {
                    position: 'absolute',
                    justifyContent: 'end',
                    padding: {base: `${remCalc(8)} ${remCalc(8)} ${remCalc(8)}`, md: `${remCalc(12)} ${remCalc(8)}`},
                },
                closeIcon: {
                    sx: {
                        '& button': {
                            maxW: {base: `${remCalc(16)}`, md: ``},
                            maxH: {base: `${remCalc(16)}`, md: ``},
                        },
                    },
                },
            },
            switchLocale: {
                dialogContainer: {
                    alignItems: 'center',
                },
                dialog: {
                    w: {base: '100%', md: '80%'},
                    h: {base: 'auto'},
                    maxW: {base: `calc(100% - ${remCalc(32)})`, md: remCalc(716), lg: remCalc(980), xl: 'none'},
                },
                header: {
                    position: 'absolute',
                    justifyContent: 'end',
                    color: 'color.text.white',
                    padding: `${remCalc(8)} ${remCalc(8)} ${remCalc(12)}`,
                },
            },
            NewsletterModal: {
                dialogContainer: {
                    alignItems: 'start',
                    zIndex: 'tooltip',
                },
                dialog: {
                    h: {base: `calc(100% - ${remCalc(48)})`, md: `calc(100% - ${remCalc(64)})`},
                    maxW: {base: remCalc(400), md: remCalc(716), lg: remCalc(1020)},
                    maxH: {base: remCalc(870)},
                },
                header: {
                    pt: 'spacing.6',
                    pb: 'spacing.3',
                    top: '0',
                    position: 'sticky',
                    bg: 'color.background.white',
                },
                body: {
                    p: 0,
                },
                imageContainer: {
                    minH: 'unset',
                },
            },
            wishlistSize: {
                dialogContainer: {
                    alignItems: 'center',
                },
                dialog: {
                    maxW: remCalc(874),
                    h: 'auto',
                    mx: 'spacing.4',
                },
                body: {
                    pr: 'spacing.3',
                },
                header: {
                    justifyContent: 'end',
                },
            },
            mediaZoom: {
                dialogContainer: {
                    alignItems: 'stretch',
                },
                dialog: {
                    m: 0,
                    borderRadius: 0,
                    maxW: '100vw',
                    maxH: '100dvh',
                    h: '100dvh',
                    w: '100vw',
                },
                header: {
                    position: 'absolute',
                    zIndex: 2,
                    right: 0,
                    top: 0,
                    justifyContent: 'flex-end',
                    alignItems: 'end',
                    p: 'spacing.8',
                    flexDirection: 'column-reverse',
                },
                dialogWrapper: {
                    h: '100%',
                    flex: 1,
                },
                bodyWrapper: {
                    h: '100%',
                    p: 0,
                    flex: 1,
                    overflowY: 'hidden',
                },
                body: {
                    p: 0,
                    h: '100%',
                    flex: 1,
                    overflow: 'hidden',
                },
                closeIcon: {
                    pr: 'spacing.4',
                },
                footer: {
                    p: 0,
                    m: 0,
                    mt: 0,
                },
            },
        },
    },
}

export default modal
